import React from "react";
import { createContext, Dispatch } from "react";
import { ActionMap } from "utils/store";

type InitialStateType = {
  schedule: {
    refresh: boolean;
  };
};

export const courseCreateInitialState = {
  schedule: {
    refresh: false,
  },
};

export const CourseCreateContext = createContext<{
  state: InitialStateType;
  dispatch: Dispatch<Actions>;
}>({
  state: courseCreateInitialState,
  dispatch: () => null,
});

export enum CourseCreateActionTypes {
  RefreshSchedule = "REFRESH_SCHEDULE",
}

type Payload = {
  [CourseCreateActionTypes.RefreshSchedule]: boolean;
};

export type Actions = ActionMap<Payload>[keyof ActionMap<Payload>];

export const courseCreateReducer = (state: InitialStateType, action: Actions): InitialStateType => {
  switch (action.type) {
    case CourseCreateActionTypes.RefreshSchedule:
      return { ...state, schedule: { refresh: !state.schedule.refresh } };

    default:
      return state;
  }
};

export const CourseCreateProvider = ({ children }: React.PropsWithChildren) => {
  const [state, dispatch] = React.useReducer(courseCreateReducer, courseCreateInitialState);

  const value = { state, dispatch };

  return <CourseCreateContext.Provider value={value}>{children}</CourseCreateContext.Provider>;
};

export function useCourseCreate() {
  const context = React.useContext(CourseCreateContext);
  if (context === undefined) {
    throw new Error("useCourseCreate must be used within a SurveyProvider");
  }
  return context;
}
